/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import FormComponent from "../../../../components/FormComponent";
import PersonalInputDetails from "./PersonalInputDetails";
import { Button, Form, Spin, message } from "antd";
import PersonalAddress from "./PersonalAddress";

import { patchOnboardForm } from "../../../../actionsMethods/masterMethods";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";

function PersonalDetails({ screen, currentScreen, check, apiResponse }) {
  const [loading, setLoading] = useState(false);
  const [disableContinue, setDisableContinue] = useState({
    otp1: true,
    otp2: true,
  });

  const history = useLocation();
  let userData = JSON.parse(localStorage.getItem("userinfo"));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error, result, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  useEffect(() => {
    form.resetFields();
  }, [check]);

  useEffect(() => {
    if (
      result !== null &&
      result?.miscellaneousDto["name"] !== null &&
      currentScreen === 2
    ) {
      let temp = {
        ...history?.state,
        premiseDetails: { ...result?.cpDetails?.premiseDetails },
        miscellaneousDetails: { ...result?.cpDetails?.miscellaneousDetails },
        screen: 2,
      };
      navigate("", {
        state: temp,
      });
      screen(3);
    }
    if (error !== null && currentScreen === 2) {
      console.log(error);
      message.error(error?.message);
    }
  }, [fetching]);

  let convertToDate = (date) => {
    let today = new Date(date);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();
    today = `${dd}-${mm}-${yyyy}`;
    return today;
  };

  let personalInitialValues = {
    Name: apiResponse?.miscellaneousDto?.name,
    ContactNo: apiResponse?.premiseDto?.phone,
    AlternateContacNo: apiResponse?.premiseDto?.mobilePhone,
    EmailId: apiResponse?.premiseDto?.emailId,
    EmailId2: apiResponse?.premiseDto?.personalEmailId,
    Dob: apiResponse?.miscellaneousDto?.dob
      ? moment(new Date(apiResponse?.miscellaneousDto?.dob), "DD-MM-YYYY")
      : null,
    ResidentialAddressLine1:
      apiResponse?.miscellaneousDto?.residentialAddressLine1,
    ResidentialAddressLine2:
      apiResponse?.miscellaneousDto?.residentialAddressLine2,
    PINCode: apiResponse?.miscellaneousDto?.residentialAddressPincode,
    City: apiResponse?.miscellaneousDto?.residentialAddressCity,
    State: apiResponse?.miscellaneousDto?.residentialAddressState,
    EducationalQualification:
      apiResponse?.miscellaneousDto?.educationalQualification,
    MarriageStatus: apiResponse?.miscellaneousDto?.maritalStatus,
    ResidentialAddressLine10:
      apiResponse?.miscellaneousDto?.residentialAddressLine1,
    ResidentialAddressLine20:
      apiResponse?.miscellaneousDto?.residentialAddressLine2,
    PINCode1: apiResponse?.miscellaneousDto?.residentialAddressPincode,
    City1: apiResponse?.miscellaneousDto?.residentialAddressCity,
    State1: apiResponse?.miscellaneousDto?.residentialAddressState,
    contactNumber: apiResponse?.premiseDto?.contactNumber,
    cpInCharge: apiResponse?.premiseDto?.cpInCharge,
  };

  useEffect(() => {
    if (apiResponse) {
      form.setFieldsValue(personalInitialValues);
    }
  }, [apiResponse]);

  let preFiledData = history.state;
  let miscellaneous = preFiledData?.miscellaneousDetails;

  console.log(preFiledData);

  const onSubmitFormData = (values) => {
    let data2 = {
      personalDetailsDto: {
        mobilePhone: values?.AlternateContacNo,
        phone: values?.ContactNo,
        emailId: values?.EmailId,
        personalEmailId: values?.EmailId2,
        name: values?.Name,
        dob: convertToDate(values?.Dob?._d),
        permanentAddressLine1: values?.ResidentialAddressLine1,
        permanentAddressLine2: values?.ResidentialAddressLine2,
        permanentAddressPincode: values?.PINCode,
        permanentAddressCity: values?.City,
        permanentAddressState: values?.State,
        residentialAddressLine1: values?.ResidentialAddressLine10,
        residentialAddressLine2: values?.ResidentialAddressLine20,
        residentialAddressPincode: values?.PINCode1,
        residentialAddressCity: values?.City1,
        residentialAddressState: values?.State1,
        educationalQualification: values?.EducationalQualification,
        maritalStatus: values?.MarriageStatus,
        marriageDate: convertToDate(values?.MarriageDate?._d),
        contactNumber: values?.contactNumber,
        cpInCharge: values?.cpInCharge,
      },
    };
    dispatch(
      patchOnboardForm(data2, userData?.userName, apiResponse.premiseId)
    );
  };

  const backPage = () => {
    screen(1);
  };

  const formProps = {
    name: "PersonalDetails",
    className: "register-form",
    initialValues: {
      //   layout: formLayout,
    },
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  const formLayout = "vertical";

  const [form] = Form.useForm();

  const disabledDateNext = (current) => {
    return current > moment().startOf("day");
  };

  return (
    <Spin spinning={fetching || loading}>
      <div>
        <div className="firm-container">
          <div className="">
            <FormComponent
              formProps={formProps}
              formLayout={formLayout}
              form={form}
              initialValues={{
                Name: miscellaneous?.name,
                ContactNo: preFiledData?.premiseDetails?.phone,
                AlternateContacNo: preFiledData?.premiseDetails?.mobilePhone,

                EmailId: preFiledData?.premiseDetails?.emailId,

                Dob: miscellaneous?.dob
                  ? moment(new Date(miscellaneous?.dob), "DD-MM-YYYY")
                  : null,
                ResidentialAddressLine1: miscellaneous?.residentialAddressLine1,
                ResidentialAddressLine2: miscellaneous?.residentialAddressLine2,
                PINCode: miscellaneous?.residentialAddressPincode,
                City: preFiledData?.miscellaneousDetails
                  ?.residentialAddressCity,
                State: miscellaneous?.residentialAddressState,
                EducationalQualification:
                  miscellaneous?.educationalQualification,
                MarriageStatus: miscellaneous?.maritalStatus,
                ResidentialAddressLine10:
                  miscellaneous?.residentialAddressLine1,
                ResidentialAddressLine20:
                  miscellaneous?.residentialAddressLine2,
                PINCode1: miscellaneous?.residentialAddressPincode,
                City1: miscellaneous?.residentialAddressCity,
                State1: miscellaneous?.residentialAddressState,
                contactNumber: preFiledData?.premiseDetails?.contactNumber,
                cpInCharge: preFiledData?.premiseDetails?.cpInCharge,
              }}
            >
              <PersonalInputDetails
                form={form}
                disabledDateNext={disabledDateNext}
                setDisableContinue={setDisableContinue}
                disableContinue={disableContinue}
                apiResponse={apiResponse}
              />
              <PersonalAddress
                form={form}
                setLoading={setLoading}
                disabledDateNext={disabledDateNext}
                check={check}
              />
            </FormComponent>
          </div>
        </div>
        <div className="button-container1">
          <div className="steps-action">
            <Button className="back-button" onClick={() => backPage()}>
              {"BACK"}
            </Button>
            <Button
              htmlType="submit"
              className="next-button"
              form="PersonalDetails"
              key="submit"
              disabled={
                !disableContinue.otp1 && !disableContinue.otp2 ? false : true
              }
            >
              {"CONTINUE"}
            </Button>
          </div>
        </div>
        {/* )} */}
      </div>
    </Spin>
  );
}

export default PersonalDetails;
